/* global axios */
import ApiClient from '../ApiClient';

class PipelineStagesAPI extends ApiClient {
  constructor() {
    super('pipeline_stages', {
      saas: true,
      accountScoped: true,
    });
  }

  get url() {
    if (!this.pipelineId) {
      throw new Error('pipelineId is required for PipelineStagesAPI');
    }
    return `${this.baseUrl()}/pipelines/${this.pipelineId}/${this.resource}`;
  }

  getStages(pipelineId) {
    this.pipelineId = pipelineId;
    return axios.get(this.url);
  }

  createStage(pipelineId, data) {
    this.pipelineId = pipelineId;
    return axios.post(this.url, { pipeline_stage: data });
  }

  updateStage(pipelineId, id, data) {
    this.pipelineId = pipelineId;
    return axios.patch(`${this.url}/${id}`, { pipeline_stage: data });
  }

  deleteStage(pipelineId, id) {
    this.pipelineId = pipelineId;
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new PipelineStagesAPI();
